import { BrowserRouter } from "react-router-dom";

import { ThemeProvider } from "@mui/material";

import theme from "../../theme";
import Main from "../Main";

const App = () => {
	return (
		<ThemeProvider theme={theme}>
			<BrowserRouter>
				<Main />
			</BrowserRouter>
		</ThemeProvider>
	);
};

export default App;
